import script from "./BillingTrialHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingTrialHeader.vue?vue&type=script&setup=true&lang=js"

import "./BillingTrialHeader.vue?vue&type=style&index=0&id=764da292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764da292"]])

export default __exports__